import BaseInitFlowAction from "@/action/actions/BaseInitFlowAction"
import ActionId from "@/action/ActionId"
import { applicationState, sessionState } from "@/state"
import accountState from "@/state/AccountState"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

class InitAccountFlowAction extends BaseInitFlowAction {
    constructor(actionId, route, response) {
        super(actionId, route, response)
    }

    async initData() {
        await super.initData()
        const response = this.response
        applicationState.application = response.application || {}
        accountState.account = response.start.account || {}
        sessionState.dynamicProviderKey = new DynamicProviderKey(accountState.account.providerKey)
    }
}

export default InitAccountFlowAction
